<template>
  <el-container>
    <el-header style="height: 70px;background-color: #FFFFFF">
      <div class="header-info">
        <img class="header-logo" src="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/logo-s.png">
        <a class="company-name">广东良方药业有限公司</a>
        <div class="info-navi">
          <ul>
<!--            <li>-->
<!--              <el-link class="navi-link" href="/hy-mic-sy/home" :underline="false">首页</el-link>-->
<!--            </li>-->
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/news" :underline="false">行业资讯</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/about" style="color: #0270FF" :underline="false">关于我们</el-link>
            </li>
            <li>
              <el-link class="navi-link" href="/hy-mic-sy/contactUs" :underline="false">联系我们</el-link>
            </li>
          </ul>
        </div>
      </div>
    </el-header>
    <el-main style="margin: 0 auto;padding: 0;width: 1200px; padding-top: 10px">
      <div class="main-banner">
        <el-carousel :interval="4000" height="400px" indicator-position="none">
          <el-carousel-item v-for="item in banners" :key="item" style="background-color: #FFFFFF">
            <el-image :src='item.url'></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="company-profile">
        <div class="about-us">
          <img src="../../../../static/images/home/aboutUs/profile.png">
          <div class="about-us-profile">
            <h3>公司简介</h3>
            <p style="margin-top: 40px;width: 450px;line-height: 32px;font-size: 18px">
              广东良方药业有限公司成立于2005年01月07日，注册地位于湛江市赤坎区广湛路口西侧荣和翠苑A幢一门102房。经营范围包括许可项目：药品批发；第三类医疗器械经营；药品互联网信息服务；第二类增值电信业务；卫生用品和一次性使用医疗用品生产。
            </p>
          </div>
        </div>
        <div class="about-us">
          <div class="about-us-profile">
            <h3>企业文化</h3>
            <p style="margin-top: 40px;width: 450px;line-height: 32px;font-size: 18px">
              有优秀的发展加盟优势：立足本土，品牌影响力强大；
              具有丰富的上下游合作资源及第三终端客户覆盖广泛；强大的运营团队及整体凝聚力；公司创始人深谙医药行业、广阔的人脉资源。
            </p>
          </div>
          <img src="../../../../static/images/home/aboutUs/culture.png">
        </div>
      </div>
    </el-main>
    <el-footer style="height: 70px;padding-top: 40px">
      <div class="footer-info">
        <p style="line-height: 25px">
          版权所有©广东良方药业有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/xinxizheng.jpg" target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2020-0099
          </a> <br>
          ICP主体备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank">
            粤ICP备2022011696号-1
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/certificate/yinyezhizhao.jpg" target="_blank">营业执照副本</a>
        </p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import Login from "@/views/login/LoginApp";

export default {
  data() {
    component:{
      Login
    }
    return {
      activeName: 'first',
      banners: [
        {
          name: 'banner1',
          url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.616pic.com%2Fbg_w1180%2F00%2F03%2F29%2Fzu3L5I3Cah.jpg&refer=http%3A%2F%2Fpic.616pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668217410&t=cbaa27bda78de8cea75e03b8080e3dc9'
        }
      ],
      itemBanners: [
        {name: 'banner1', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/file24FDEkGnat.jpg'},
        {name: 'banner2', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileD5pHJsc8at.jpg'},
        {name: 'banner3', url: 'http://lyly360.oss-cn-shenzhen.aliyuncs.com/fileDDwnrtifzD.jpg'}
      ]
    }
  },
  methods: {}
}
</script>

<style>
.about-us-profile h3{
  font-weight: 600;
}
.about-us-profile{
  float: left;
  width: 590px;
  height: 450px;
  margin-left: 20px;
  padding-top: 20px;
  padding-left: 50px;
  text-align: left;
}
.about-us img {
  border-radius: 6px;
  width: 520px;
  height: 350px;
  float: left;
}

.about-us {
  height: 550px;
  padding-top: 90px;
}

.company-profile {
}

.product-img img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.content-tiny-program-info span {
  display: inline-block;
  margin-left: 10px;
  font-size: 18px;
}

.content-tiny-program-info img {
  height: 25px;
  width: 25px;
  line-height: 30px;
}


.second-banner img {
  width: 700px;
  height: 350px;
}

.footer-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
}

.el-link {
  font-size: 18px;
}

ul {
  display: flex;
  list-style: none;
  padding: 0;
  line-height: 40px;
  height: 70px;
  float: right;
  margin-right: 50px;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-left: 40px;
  line-height: 70px;
}

.info-navi {
  float: right;
  width: 750px;
  height: 70px;
  text-align: right;
}

.main-banner {
}

.el-header, .el-footer {
  color: #333;
  text-align: left;
  line-height: 70px;
  height: 70px;
}

.header-info {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.header-logo {
  width: 65px;
  height: 65px;
  float: left;
}

.header-info .company-name {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
</style>
<style scoped>

</style>
